import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    root: {
      display: 'grid',
      gridTemplateColumns: ({ stepsCount }) =>
        `repeat(${stepsCount}, minmax(0,1fr))`,
      gap: 10,
    },
    stepWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginRight: spacing(2),
      width: 24,
      height: 24,
    },
    date: {
      fontSize: 10,
      lineHeight: '14px',
      [breakpoints.up('xLg')]: {
        fontSize: 12,
      },
      [breakpoints.up('xl')]: {
        fontSize: 14,
        lineHeight: '18px',
      },
    },
    lineWrapper: {
      display: 'flex',
      alignItems: 'center',
      height: 24,
      width: '100%',
      marginTop: spacing(5),
    },
    dot: {
      boxSizing: 'border-box',
      backgroundColor: primary.white,
      border: `2px solid ${primary.bluish1}`,
      borderRadius: '50%',
      flexShrink: 0,
      marginLeft: spacing(1.5),
      marginRight: spacing(4),
      width: 12,
      height: 12,
    },
    dotActive: {
      backgroundColor: primary.bluish1,
    },
    line: {
      borderTop: `2px dotted ${primary.bluish1}`,
      width: 'calc(100% - 34px)',
      height: 0,
    },
    lineActive: {
      borderTop: `2px solid ${primary.bluish1}`,
    },
  })
);

const CycleTimeline = ({ className = undefined, steps = [] }) => {
  const classes = useStyles({ stepsCount: steps.length });

  return (
    <div className={classNames(classes.root, className)}>
      {steps.map(step => {
        const { icon: Icon, startsAt, endsAt, isActive } = step;

        return (
          <div key={`timeline_step_${step.id}`}>
            <div className={classes.stepWrapper}>
              <Icon className={classes.icon} />
              <div>
                <Typography variant="subtitle1">{step.name}</Typography>
                <Typography
                  variant="caption"
                  className={classes.date}
                >{`${startsAt} ${endsAt ? '-' : ''} ${
                  endsAt || ''
                }`}</Typography>
              </div>
            </div>
            <div className={classes.lineWrapper}>
              <div
                className={classNames(classes.dot, {
                  [classes.dotActive]: isActive,
                })}
              />
              <div
                className={classNames(classes.line, {
                  [classes.lineActive]: isActive,
                })}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

CycleTimeline.propTypes = {
  className: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.object),
};

export default CycleTimeline;
